<template>
  <v-dialog v-model="exibir" fullscreen hide-overlay transition="dialog-bottom-transition" scrollable>
    <v-card tile>
      <v-toolbar dark color="primary">
        <v-toolbar-title>Busca de Produtos</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click.native="exibir = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>

        <v-layout row wrap justify-center class="mt-2">
          <v-flex sm6>
            <v-text-field v-model="buscarproduto" ref="buscarproduto" solo placeholder="Digite a descrição do produto ou a referência" @keyup.enter="buscarProdutoPorDescricao" @keyup.esc="exibir = false; $refs.referencia.focus()" @focus="$event.target.select()"></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout row wrap justify-center>
          <v-flex sm6>

            <h1 v-if="exibirMensagem">Produto não encontrado</h1>

            <v-list two-line v-if="produtosBusca.length > 0">

              <template v-for="(produto, index) in produtosBusca">
                <v-list-item :key="produto.id" @click="selecionarProduto(produto)">
                  <v-list-item-content>
                    <v-list-item-subtitle>Referência: {{ produto.referencia }}</v-list-item-subtitle>
                    <v-list-item-title>{{ produto.descricao }}</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-list-item-action-text class="title">R$ {{ produto.valor_venda | valorBR}}</v-list-item-action-text>
                    <v-list-item-action-text>Estoque: {{ produto.estoque }} {{ produto.unidade }}</v-list-item-action-text>
                  </v-list-item-action>
                </v-list-item>
                <v-divider :key="index * 1000"></v-divider>
              </template>

            </v-list>

          </v-flex>
        </v-layout>

      </v-card-text>

      <div style="flex: 1 1 auto;"></div>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'busca-produto',
    data: () => ({
      exibir: false,
      buscarproduto: '',
      exibirMensagem: false,
      produtosBusca: [],
      buscando: false
    }),

    methods: {
      abrir() {
        this.exibir = true;
        this.setFocus('buscarproduto');
      },
      
      fechar() {
        this.exibir = false;
      },

      async buscarProdutoPorDescricao() {
        this.exibirMensagem = false;
        this.buscando = true;
        this.produtosBusca = await this.$store.dispatch('produtos/buscarProdutoPorDescricao', this.buscarproduto);
        if (this.produtosBusca.length == 0) {
          this.exibirMensagem = true;
        }
        this.buscando = false;
      },

      selecionarProduto(produto) {
        this.$emit('selecionar:produto', produto);
        this.fechar();
      },
    }
  }
</script>

<style scoped>
  .v-toolbar {
    flex: 0 1 auto;
  }
</style>